export type FocalPoint = { x: number; y: number };

/**
 * Convert a focal point to a CSS `object-position` value.
 * Accepts either a concrete focal point, null, or undefined.
 * Falls back to "center center" when no focal point is provided.
 */
export function focalPointToObjectPosition(focalPoint?: FocalPoint | null): string {
    if (!focalPoint || typeof focalPoint.x !== 'number' || typeof focalPoint.y !== 'number') {
        return 'center center';
    }
    const x = Math.max(0, Math.min(100, focalPoint.x));
    const y = Math.max(0, Math.min(100, focalPoint.y));
    return `${x}% ${y}%`;
}

/**
 * Resolve the effective focal point for an article: article-level override wins,
 * then the shared media-level focal point, then null (renders centered).
 */
export function resolveEffectiveFocalPoint(articleOverride?: FocalPoint | null, mediaShared?: FocalPoint | null): FocalPoint | null {
    return articleOverride ?? mediaShared ?? null;
}
